module.exports = __webpack_public_path__ + "img/anhanguerajundiai.30fe0995.png";